import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PipelinesService} from "../../../../pipelines.service";

@Component({
  selector: 'pipelines-panel-project-attributes',
  standalone: false,
  templateUrl: './pipelines-panel-project-attributes.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-project-attributes.component.scss', '../../pipelines-table.component.scss']
})
export class PipelinesPanelProjectAttributesComponent implements OnInit {
  @Input() detail:any;
  public expanded:boolean = false
  public rows: { label: string; key: string }[][] = [];
  public attributeDetail:any;

  private displayFields: { label: string; key: string }[] = [
    { label: 'Application Status', key: 'Application Status' },
    { label: 'LLCI', key: 'LLCI' },
    { label: 'Site Type', key: 'Site Type' },
    { label: 'Building Type', key: 'Building Type'},
    { label: 'Loss Reason', key: 'Loss Reason'},
    { label: 'Special Set-Aside', key: 'Special Set-Aside'},
    { label: 'Census Tract Minority Population', key: 'Census Tract Minority Population'},
    { label: 'Minimum Set-Aside', key: 'Minimum Set-Aside'},
    { label: 'Supportive Services', key: 'Supportive Services'},
    { label: 'Closing Category', key: 'Closing Category'},
    { label: 'Operational Status', key: 'Operational Status'},
    { label: 'Supportive Services at Cost to Partnership', key: 'Supportive Services at Cost to Partnership'},
    { label: 'Closing in Projected Year', key:'Closing in Projected Year'},
    { label: 'Opportunity Zone', key: 'Opportunity Zone'},
    { label: 'Supportive Services Included', key: 'Supportive Services Included'},
    { label: 'Community', key: 'Community'},
    { label: 'Prospect Priority', key: 'Prospect Priority'},
    { label: 'Transaction Type', key: 'Transaction Type'},
    { label: 'Construction', key: 'Construction'},
    { label: 'Prospect Probability', key: 'Prospect Probability'},
    { label: 'Warehouse', key: 'Warehouse'},
    { label: 'Debt-Only', key: 'Debt-Only'},
    { label: 'Resident', key: 'Resident'}

  ];
  constructor(private _pipelineService: PipelinesService) { }

  ngOnInit(): void {
    this._formatAttributes()
    this.rows = this._pipelineService.splitExpandedRowChunk(this.displayFields, 3)
  }

  public toggleExpand(){
    this.expanded = !this.expanded
  }

  private _formatAttributes(){
    let attributes = this.detail.attributes
    this.attributeDetail = attributes.reduce((acc:any, attr: any) => {
      acc[attr.attribute_type] = attr.attribute
      return acc
    }, {})
  }

}
